import { render, staticRenderFns } from "./DetailLayer.vue?vue&type=template&id=ca59b226&scoped=true&"
import script from "./DetailLayer.vue?vue&type=script&lang=js&"
export * from "./DetailLayer.vue?vue&type=script&lang=js&"
import style0 from "./DetailLayer.vue?vue&type=style&index=0&id=ca59b226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca59b226",
  null
  
)

export default component.exports